<template>
  <div style="position: relative">
    <div class="profile__container--content__mysalons primary-font">
      <title-and-edit
        currentViewTitle="Mine Gavekort"
        :hideEditButton="true"
        :layout="layout"
      />
      <div v-if="!isLoading">
        <no-content
          hideButton
          v-if="myGiftCards.length == 0"
          title="Ingen gavekort ennå."
          icon="fxt-gift"
          :layout="layout"
        />
        <div v-else class="pt-5">
          <!-- <title-and-edit currentViewTitle="Gavekort" :layout="layout" /> -->
          <profile-dropdown
            v-if="layout == 'portal'"
            :items="giftCardsSalon"
            @select-item="updateGiftCardsList"
          ></profile-dropdown>
          <masonry v-bind="masonry">
            <my-gift-card
              style="margin-bottom: 30px"
              v-for="(item, index) in filteredMyGiftCards"
              :item="item"
              :class="[layout == 'portal' ? 'fixit-design' : 'salon-design']"
              :key="index"
              @show-barcode="showBarcode(item)"
            ></my-gift-card>
          </masonry>
        </div>
      </div>
      <div v-else>
        <v-overlay
          :value="isLoading"
          color="white"
          absolute
          style="height: 600px"
        >
          <v-progress-circular
            color="var(--v-primary-base)"
            indeterminate
            size="64"
          ></v-progress-circular>
        </v-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import Giftcard from "./components/Giftcard.vue";
import { NoContent, TitleAndEdit } from "../../../Common/CommonComponents";
import MyGiftCard from "@fixit/v-my-gift-card/src/MyGiftCard.vue";
import GiftCardSvc from "../../../../services/gift-card-svc";
import ProfileDropdown from "../../../Common/CommonComponents/ProfileDropdown.vue";
let giftCardSvc = null;

export default {
  components: {
    Giftcard,
    NoContent,
    TitleAndEdit,
    MyGiftCard,
    ProfileDropdown,
  },
  props: {
    layout: {
      required: false,
      default: "chain",
      type: String,
    },
  },
  data() {
    return {
      masonry: {
        cols: {
          default: 2,
          [this.$vuetify.breakpoint.thresholds.md]: 2,
          [this.$vuetify.breakpoint.thresholds.sm]: 2,
          [this.$vuetify.breakpoint.thresholds.xs]: 1,
        },
        gutter: { default: "20px" },
      },
      myGiftCards: [],
      filteredMyGiftCards: [],
      giftCardsSalon: [],
      isLoading: false,
      selectedGiftCardsSalon: "",
    };
  },
  computed: {
    giftCardApi() {
      return this.layout == "portal"
        ? process.env.VUE_APP_FIXIT_GIFT_CARD_API_URL
        : this.$config.VUE_APP_FIXIT_GIFT_CARD_API_URL
        ? this.$config.VUE_APP_FIXIT_GIFT_CARD_API_URL
        : process.env.VUE_APP_FIXIT_GIFT_CARD_API_URL;
    },
  },
  methods: {
    updateGiftCardsList(salon) {
      this.filteredMyGiftCards =
        salon == "Alle"
          ? [...new Set(this.myGiftCards)]
          : this.myGiftCards.filter((x) => x.name == salon);
      this.selectedGiftCardsSalon = salon;
    },
    showBarcode(item) {
      this.layout == "portal"
        ? this.$router.push({
            name: "Bruk gavekort",
            params: { barcode: item.barcode, usageArea: item.usageArea },
          })
        : this.$router.push({
            query: {
              title: "bruk-gavekort",
              barcode: item.barcode,
              usageArea: item.usageArea,
            },
          });
    },
  },
  async created() {
    this.isLoading = true;
    giftCardSvc = await GiftCardSvc(this.$axios);
    this.myGiftCards = await giftCardSvc.GetMyGiftCards(
      this.giftCardApi,
      this.layout === "chain"
        ? this.$store.getters["salon/getSiteIds"]
          ? this.$store.getters["salon/getSiteIds"]
          : this.$store.getters["site/getChainSiteIds"]
        : []
    );
    this.filteredMyGiftCards = this.myGiftCards;
    this.giftCardsSalon = this.myGiftCards
      ? this.myGiftCards.map((x) => x.name)
      : [];
    this.isLoading = false;
  },
  beforeDestroy() {
    giftCardSvc = null;
  },
};
</script>
